import { useTranslation } from "react-i18next";
import { Field as BaseField } from "rc-field-form";
import Field from "../../../../../components/Field";
import Switch from "../../../../../components/Inputs/Switch";
import Select from "../../../../../components/Inputs/Select";

function Settings({ form, columns }) {
    const { t } = useTranslation();

    return (
        <div className="w-100 row">
            <div className="col-6">
                <Field name="replaceJobWhenItIsChanged" valuePropName="checked">
                    <Switch id="replaceJobWhenItIsChanged">{t("replace-job-when-it-is-changed")}</Switch>
                </Field>

                <Field name="calculateOverMultipleProfiles" valuePropName="checked">
                    <Switch id="calculateOverMultipleProfiles">
                        {t("calculate-timesheets-over-multiple-profiles")}
                    </Switch>
                </Field>

                <BaseField shouldUpdate>
                    {({ }, { }, { getFieldValue }) => {
                        const calculateOverMultipleProfiles = getFieldValue("calculateOverMultipleProfiles");
                        return calculateOverMultipleProfiles ? (
                            <Field
                                name="method"
                                label={t("calculation-method")}
                                rules={[
                                    {
                                        required: true,
                                        message: t("required-calculation-method")
                                    }
                                ]}
                            >
                                <Select>
                                    <Select.Option value="prorated">
                                        {t("prorated")}
                                    </Select.Option>
                                    {/* <Select.Option value="occurs">
                                        {t("when-occurs")}
                                    </Select.Option> */}
                                    {/* <Select.Option value="has-more-hours">
                                        {t("when-has-more-hours")}
                                    </Select.Option> */}
                                </Select>
                            </Field>
                        ) : null
                    }}
                </BaseField>
            </div>
        </div>
    );
}

export default Settings;
